<template>
  <div class="success-wrapper">
    <div class="success-log">
      <img src="@/assets/imgs/icon_correct.png" alt="">
      <p>兑换成功</p>
    </div>
    <div class="content">稍后我们的小助手会与您取得联系</div>
    <div class="content">您也可以直接联系我们的小助手</div>
    <img class="er-code" src="@/assets/imgs/teacher_er.png" alt="">
  </div>
</template>

<script>
  export default {
    name: "ChangeSuccess"
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .success-wrapper {
    box-sizing: border-box;
    min-height: 100vh;
    padding: 8px 20px;
    background-color: #F3F5F9;
    font-size: 14PX;
    color: #333;
  }
  .success-log{
    margin-top: 40px;
    margin-bottom: 40px;
    text-align: center;
    img{
      width: 60px;
      height: 60px;
      border-radius: 50px;
    }
    p{
      margin-top: 8px;
      font-size: 18PX;
    }
  }
  .content{
    text-align: center;
    margin-top: 6px;
  }
  .er-code{
    width: 160px;
    height: 160px;
    display: block;
    margin: 20px auto;
  }
</style>




// WEBPACK FOOTER //
// app/pages/tabs/Mine/ChangeSuccess.vue